export default "assets/images/icons/facebook-b8b8289d.svg";